import { ISearchFlight } from "@/shared/api/aviabooking"

/** null means the supplier has not confirmed seat availability. */
export const getFreeSeatsCount = (flight: ISearchFlight): number | null => {
    if (!flight.segments?.length || !flight.prices?.length) return null

    const counts = flight.prices.map((price) => {
        const perSegment = flight.segments.map((_, index) => {
            const classes = price.booking_classes?.filter(
                (bookingClass) => bookingClass.segment_number === index + 1
            )
            if (!classes?.length) return null
            const values = classes.map((bookingClass) => bookingClass.free_seat_count)
            if (values.some((value) => !Number.isFinite(value) || value < 0)) return null
            return Math.max(...values)
        })
        // A confirmed empty segment makes this price unavailable even if
        // availability for another segment is missing.
        if (perSegment.includes(0)) return 0
        if (perSegment.includes(null)) return null
        return Math.min(...(perSegment as number[]))
    })

    // A known purchasable price remains available even if another price is unknown.
    const knownCounts = counts.filter((count): count is number => count !== null)
    if (knownCounts.some((count) => count > 0)) return Math.max(...knownCounts)
    // Other prices may still be purchasable when a supplier omits their classes.
    if (counts.includes(null)) return null
    return 0
}
